export default "__VITE_ASSET__BL14ckHV__"